import { useEffect, useRef } from "react";

const ScrollFixedSearch = (ref, hideClass = "scroll-up", compactClass = "compact") => {
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (ref?.current) {
        if (currentScrollY > lastScrollY.current) {
          ref.current.classList.add(hideClass);
          ref.current.classList.remove(compactClass);
        } else {
          ref.current.classList.remove(hideClass);
          ref.current.classList.add(compactClass);
        }
        if (currentScrollY === 0) {
          ref.current.classList.remove(compactClass);
        }
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [ref, hideClass, compactClass]);
};

export default ScrollFixedSearch;
